import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import { FaArrowUp } from "react-icons/fa";
import logo from "./../assets/Logo.png"; // University Logo
import "../css/footer.css";

const Footer_Eng = ({ visitorCount }) => {
    const [showArrow, setShowArrow] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setShowArrow(window.scrollY > 200);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <>
            {/* Top Navigation Bar */}
            <div className="top-bar">
                <nav className="top-nav">
                    <Link to="#">Feedback</Link> |
                    <Link to="#">Terms & Conditions</Link> |
                    <Link to="#">Website Policy</Link> |
                    <Link to="#">Contact</Link> |
                    <Link to="/en/sitemap">Sitemap</Link> |
                    <Link to="#">Disclaimer</Link> |
                    <Link to="#">Help</Link> |
                    <Link to="#">FAQ</Link> |
                </nav>
            </div>

            {/* Footer Section */}
            <footer className="footer">
                <Container fluid className="footer-container py-4">
                    <Row className="align-items-center">
                        {/* University Logo and Name */}
                        <Col sm="3" className="text-center text-sm-left">
                            <img src={logo} alt="University Logo" className="footer-logo" />
                            <h6 className="text-light" style={{ whiteSpace: "nowrap" }}>
                                Maharshi Valmiki Sanskrit University, Kaithal (Haryana)
                            </h6>
                        </Col>

                        {/* Copyright */}
                        <Col sm="6" className="text-center">
                            <p className="text-light fs-6">
                                © 2025 Maharshi Valmiki Sanskrit University, Kaithal (Haryana)
                            </p>
                        </Col>

                        {/* Contact Info */}
                        <Col sm="3" className="text-right">
                            <p className="text-light">
                                📧 Email:{" "}
                                <a
                                    href="mailto:helpdesk@mvsu.ac.in"
                                    style={{ color: "#3399ff", fontWeight: "bold" }}
                                >
                                    helpdesk@mvsu.ac.in
                                </a>
                            </p>
                            <p className="text-light">📞 Phone: +91 8708997181</p>
                        </Col>
                    </Row>
                </Container>

                {/* Visitor Count Section */}
                <div
                    style={{
                        backgroundColor: "#000",
                        padding: "0.8rem 0",
                        borderTop: "1px solid #333",
                    }}
                >
                    <Container>
                        <Row className="justify-content-center text-center">
                            <Col>
                                {visitorCount !== null && (
                                    <span
                                        style={{
                                            fontSize: "1.1rem",
                                            fontWeight: "600",
                                            color: "#ffc107",
                                        }}
                                    >
                                        👥 Total Visitors:{" "}
                                        <span style={{ color: "#ff5252" }}>
                                            {visitorCount.toLocaleString()}
                                        </span>
                                    </span>
                                )}
                            </Col>
                        </Row>
                    </Container>
                </div>

                {/* Scroll to top arrow */}
                {showArrow && (
                    <div onClick={scrollToTop} className="up-arrow">
                        <FaArrowUp />
                    </div>
                )}
            </footer>
        </>
    );
};

export default Footer_Eng;
